module.exports = __webpack_public_path__ + "img/ES1545.99d0ddb4.png";